import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ContentBlock from '../../Components/contentBlock/ContentBlock';
import { SimpleAncer } from '../../Components/button';
import LoginBgTwo from './LoginBgTwo';
import i18n from '../../i18n';

function Signup() {
  return (
    <LoginBgTwo>
      <div className="signup">
        <Container>
          <Row>
            <Col md={6} />
            <Col md={6}>
              <div className="content">
                <Row>
                  <Col md={12}>
                    <div className="content_container">
                      <ContentBlock
                        heading={i18n.t('lets_get_started')}
                        body={i18n.t('need_create_account_first')}
                      />
                      <form className="form">
                        <h6 className="inputLabel">
                          {i18n.t('phone_number')}*
                        </h6>
                        <div className="select_container">
                          <div className="input_box">
                            <span>+92 </span>
                            <input
                              placeholder=""
                              className="custom_input"
                              type="text"
                            />
                          </div>
                        </div>
                        <h6 className="inputLabel">{i18n.t('full_name')}*</h6>
                        <div className="input_box">
                          <input
                            placeholder=""
                            className="custom_input"
                            type="text"
                          />
                        </div>
                        <h6 className="inputLabel">
                          {i18n.t('email_address')}
                        </h6>
                        <div className="input_box">
                          <input
                            placeholder=""
                            className="custom_input"
                            type="email"
                          />
                        </div>
                        <p className="fs-14 term_condition_text">
                          {i18n.t('clicking_continue_accepting')}
                          <Link to="/">{i18n.t('terms_conditions')}.</Link>
                        </p>
                        <div className="btns_container">
                          <SimpleAncer
                            to="/otpWhenLoggingIn"
                            text={i18n.t('continue')}
                          />
                        </div>
                      </form>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </LoginBgTwo>
  );
}

export default Signup;
